// src/gates/SubscribedRoute.js
import React, { useRef, useEffect, useMemo } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { useUserQuery } from "../hooks/api_hooks/useUserQuery";
import { Box, CircularProgress } from "@mui/material";

const SubscribedRoute = ({ children }) => {
  const auth = useAuth();
  const { isLoading, isFetching, data } = useUserQuery();

  const user = data?.user;
  const isSilent = auth.activeNavigator === "signinSilent";
  const inIframe = typeof window !== "undefined" && window.self !== window.top;
  const logoutInProgress =
    typeof window !== "undefined" &&
    sessionStorage.getItem("logoutInProgress") === "1";

  const isSubscribed = useMemo(() => {
    const status = user?.stripe_data?.subscription?.toLowerCase?.();
    return status === "active" || status === "inactive";
  }, [user]);

  const wasSubscribed = useRef(false);
  useEffect(() => {
    if (isSubscribed) wasSubscribed.current = true;
  }, [isSubscribed]);

  if (inIframe) return null;

  const stillLoading =
    auth.isLoading ||
    !auth.isAuthenticated ||
    isSilent ||
    logoutInProgress ||
    isLoading ||
    isFetching;

  if (stillLoading) {
    // ✅ Already confirmed subscribed — don't flash spinner on token refresh
    if (wasSubscribed.current) return children;

    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isSubscribed && !wasSubscribed.current) {
    return <Navigate to="/checkout" replace />;
  }

  return children;
};

export default SubscribedRoute;
